import React from 'react';
import '../css/error404.css'; 
import imageNotFound from '../images/error_404.jpeg'

export const Error404 = () => {
  return (
    <div className='contenedor-error-404'>
        <img src={imageNotFound} alt='error404' />
    </div>
  )
}
